export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/rnaJCn6dmJtu1MPXc27Spv/PAGINA_10.jpg',
    alt: 'Sample page Four Strokes, Two Turns, One Power Impulse, showing the four-stroke cycle across 720 degrees of crankshaft rotation',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nbHi7Sb58b84n6MY5qis3z/PAGINA_17.jpg',
    alt: 'Sample page Cylinder Pressure Tells the Story of Each Cycle, with a cylinder pressure versus crank angle concept graph and P–V loop',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/t8GNsPHexne2i6FeCHEmNf/PAGINA_24.jpg',
    alt: 'Sample page The Head Closes the Cylinder and Controls Its Breathing, with a cut-away of the cylinder head and head gasket',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/fYmkoqznT6dHJhUun3YzxT/PAGINA_28.jpg',
    alt: 'Sample page The Crankshaft Turns Every Stroke Into Rotation, labeling main journals, crankpins, counterweights and oil passages',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2Qe2YBKVwwtBY86ZLbt3oW/PAGINA_35.jpg',
    alt: 'Sample page Power Is Torque Multiplied by Speed, with formulas and hypothetical worked examples',
  },
];
